var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"write"},[_c('ul',{staticClass:"write__list"},_vm._l((_vm.logoLimit),function(logo,index){return _c('li',{key:index,staticClass:"write__item"},[_c('img',{staticClass:"write__logo",attrs:{"src":`static/img/logo${logo}.png`,"width":"332","height":"200","alt":"logo writers"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }